var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root-supporters-item"},[_c('div',{staticClass:"supporters-item"},[_c('a',{attrs:{"href":_vm.item.url,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.getImageUrl(_vm.item.icon),"title":_vm.item.title}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }